import { useQuery } from "@tanstack/react-query";
import { attemptGetSpecificBrand } from "../../api/OrgApi";

export const useGetSpecificBrand = (brandId, options = {}) => {
  return useQuery({
    queryKey: ["specific-brand", brandId],
    queryFn: () => attemptGetSpecificBrand(brandId),
    enabled: !!brandId,
    select: (response) => response.data,
    refetchOnWindowFocus: false,
    ...options,
  });
};
